<template>
  <div class="home">
    <div class="minehead">
      <div class="changename">
        <img @click="toUserMes" class="headPic" src="../assets/headPic.png" />
        <div class="phoneNum" @click="toUserMes">
          {{ userMes.phone || "尚未登录" }}
        </div>
        <div @click="toLogin" v-if="userMes.phone" class="changePhone">
          <img src="../assets/tclogin.png" alt="" />
        </div>
      </div>
    </div>
    <!-- <img @click="toequity" style="width: 94%; margin: 0px auto 10px" src="../assets/banner2.png" /> -->
    <div class="vipcss">
      <div>
        <img v-if="userMes.paperVip" src="../assets/mine/vip2.png" alt="" />
        <img v-else src="../assets/mine/vip.png" alt="" />
        <div class="absolute" v-if="userMes.paperVip">
          <div style="font-size: 13px; color: #fff">
            {{ userMes.paperVip.vipName }}
          </div>
          <div>{{ userMes.vipExpireTime }}</div>
        </div>
      </div>
      <div class="dingwei">
        <!-- <div class="vipimg" v-if="userMes.paperVip" @click="vipTo">
          {{ userMes.exchangeCount }}张兑书卡
        </div> -->
        <div class="vipimg" v-if="!userMes.paperVip" @click="vipTo">
          立即开通
        </div>
        <div class="tuiding" v-show="userMes.paperVip" @click="tuiding">
          取消自动续费
        </div>
      </div>
    </div>
    <div class="container">
      <div class="icon-grid">
        <div
          class="icon-item"
          v-for="item in iconList"
          :key="item.id"
          @click="handleIconClick(item)"
        >
          <div class="icon-box">
            <img class="icon-image" :src="item.icon" mode="aspectFit" />
          </div>
          <span class="icon-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
    <!-- <img style="width: 93%;margin: auto;" v-if="this.beiandata == '浙ICP备2021005120号-5'" @click="toeurl" src="../assets/banner.png" alt=""> -->
    <div class="mineList">
      <div
        v-for="(item, index) in filteredMenuList"
        :key="index"
        @click="item.click"
        class="eachBlock"
      >
        <div class="eachIco">
          <img :style="item.imgStyle" :src="item.icon" />
        </div>
        <span class="eachTit">{{ item.title }}</span>
        <img class="arrow" src="../assets/arrow1.png" />
      </div>

      <el-drawer
        size="16%"
        direction="btt"
        title="客服电话"
        :visible.sync="drawer"
        :with-header="false"
      >
        <div class="kf">
          <div @click="kf(1)" style="border-bottom: 1px solid #0000001a">
            客服电话
          </div>
          <div @click="kf(2)">在线客服</div>
        </div>
      </el-drawer>
    </div>
    <div class="beian" v-if="kfshow == false" @click="beian">
      {{ beiandata }}
    </div>
    <FootTab></FootTab>
  </div>
</template>

<script>
import FootTab from "@/components/FootTab.vue";
import wx from "weixin-js-sdk";
import axios from "axios";

import VConsole from "../../src/api/vconsole.min.js";
var hjState = 1;
export default {
  name: "home",
  components: {
    FootTab,
  },
  data() {
    return {
      title: "",
      vipType: "1",
      userMes: {},
      isShowService: false,
      drawer: false,
      kfshow: false,
      beiandata: localStorage.getItem("beiantext"),
      iconList: [
        {
          id: 1,
          text: "会员",
          icon: require("../assets/mine/hy.png"),
          bgColor: "#e6f7ff",
        },
        {
          id: 2,
          text: "生成记录",
          icon: require("../assets/mine/jl.png"),
          bgColor: "#e6f7ff",
        },
        {
          id: 3,
          text: "订单",
          icon: require("../assets/mine/dd.png"),
          bgColor: "#e6f7ff",
        },
      ],
      menuList: [
        {
          title: "地址",
          icon: require("../assets/mineIco4.png"),
          click: this.toAddress,
          show: true,
        },
        {
          title: "客服",
          icon: require("../assets/mineIco5.png"),
          imgStyle: { width: "0.44rem" },
          click: this.toService,
          show: () => this.isShowService,
        },
        {
          title: "卡密兑换",
          icon: require("../assets/mineIco6.png"),
          click: this.toCdKey,
          show: () => this.beiandata == "浙ICP备2021005120号-5",
        },
        {
          title: "会员领取",
          icon: require("../assets/mineIco8.png"),
          imgStyle: { width: "0.5rem" },
          click: () => this.tovipEquity(0),
          show: () => this.beiandata == "浙ICP备2021005120号-5",
        },
        {
          title: "热门权益",
          icon: require("../assets/mineIco8.png"),
          imgStyle: { width: "0.5rem" },
          click: () => this.tovipEquity(1),
          show: () => this.beiandata != "浙ICP备2021005120号-5",
        },
      ],
    };
  },
  computed: {
    filteredMenuList() {
      return this.menuList.filter((item) => {
        if (typeof item.show === "function") {
          return item.show();
        }
        return item.show !== false;
      });
    },
  },
  created() {
    this.initPage();
  },
  mounted() {
    this.vipType = localStorage.getItem("vipType");
    this.handleUrlParams();
    this.fetchUserMes();
  },
  methods: {
    toeurl(){
      window.location.href = 'https://m.woread.diamond.aizhishifm.cn/benefitGs.html?bllProductCode=ygxzbJSAPISign2990&packageCode=PCSWLL5G31'
    },
    initPage() {
      if (window.location.href.indexOf("iread") == -1) {
        this.isShowService = true;
      }

      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/miniprogram/i)) {
        this.kfshow = true;
      }

      const kfphone =
        location.href.indexOf("hemakouyu") != -1 ? "4009933950" : "4008888202";
      localStorage.setItem("kfphone", kfphone);
    },
    //免登
    handleUrlParams() {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);
      let phone = params.get("phone");
      if (phone && phone.length == 11) {
        this.http.avoidlogin({ phone: phone }).then((res) => {
          if (res.data.status == 1) {
            this.userMes = res.data.data;

            localStorage.setItem("userMes", JSON.stringify(res.data.data));
          }
        });
      }

      let token = params.get("token");
      let openId = params.get("openId");
      let originUrl = params.get("originUrl");
      let AGRMNO = params.get("AGRMNO");

      if (AGRMNO && originUrl) {
        window.location.href = originUrl;
      }

      if (openId) {
        localStorage.setItem("openId", openId);
      }
      if (token) {
        localStorage.setItem("userMes", JSON.stringify({ user_token: token }));
      }
    },

    fetchUserMes() {
      this.http.getUserMes().then((res) => {
        if (res.data.status == 1) {
          const userMes = res.data.data;
          const localUserMes = JSON.parse(localStorage.getItem("userMes"));
          if (localUserMes && localUserMes.user_token) {
            userMes.user_token = localUserMes.user_token;
          }
          this.userMes = userMes;
          localStorage.setItem("userMes", JSON.stringify(userMes));
        }
      });
    },
    tuiding() {
      const { paperVip, phone } = this.userMes;
      let data = {
        appkey: "zxs001",
        bizcode: "wechat_sign_cancle",
        sign: "byt",
        phone: phone,
        productId: paperVip.productId,
      };
      let url = 'https://jifei.aizhishifm.com/rest/open/exec'
      const productIds = {
        0: paperVip.miniProductId,
        1: paperVip.jsapiProductId,
      };
      data.productId = productIds[hjState] || paperVip.productId;
      //通过vipCode判断是微信小程序退款还是h5退款
      if ( paperVip.vipCode === "ygxzb_h5_2990") {
        data.appkey = "zxs";
        data.bizcode = "tl_unSign_service";
        url = 'https://api.hemakouyu.com/rest/open/exec'
      }
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.flag) {
            this.$message.success("退订成功");
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch((error) => {
          console.error("请求失败:", error);
          this.$message.error("退订失败，请稍后再试");
        });
    },

    beian() {
      window.location.href = "https://beian.miit.gov.cn";
    },
    toJl() {
      this.$router.push({ name: "records", query: { type: "3" } });
    },
    vipTo() {
      if (this.userMes.phone) {
        this.$router.push({ name: "vip" });
      } else {
        this.wxState();
      }
    },
    handleIconClick(item) {
      if (!this.userMes.phone && item.id !== 2) {
        this.wxState();
        return;
      }

      switch (item.id) {
        case 1:
          this.$router.push({ name: "mineVip" });
          break;
        case 2:
          this.toJl();
          break;
        case 3:
          this.$router.push({ name: "mineOrder" });
          break;
      }
    },
    toCar() {
      this.$router.push({ name: "car" });
    },
    tovipEquity(index) {
      if (this.userMes.phone) {
        if (index == 0) {
          this.$router.push({ name: "vipEquity" });
        } else {
          window.location.href =
            "https://cdn.activity.hangzhousg.com/vip_equity/benefitVip.html?productId=ygsy4990&packageCode=PC201";
        }
      } else {
        this.wxState();
      }
    },
    mineVip() {
      if (this.userMes.phone) {
        this.$router.push({ name: "mineVip" });
      } else {
        this.wxState();
      }
    },
    toMineOrder() {
      if (this.userMes.phone) {
        this.$router.push({ name: "mineOrder" });
      } else {
        this.wxState();
      }
    },
    toBookCard() {
      if (this.userMes.phone) {
        this.$router.push({ name: "bookCard" });
      } else {
        this.wxState();
      }
    },
    toAddress() {
      if (this.userMes.phone) {
        sessionStorage.setItem("fromPath", "");
        this.$router.push({ name: "address" });
      } else {
        this.wxState();
      }
    },
    toService() {
      if (this.kfshow) {
        this.drawer = true;
      } else {
        window.location.href = `tel:${localStorage.getItem("kfphone")}`;
      }
    },
    kf(item) {
      if (item == 1) {
        window.location.href = `tel:${localStorage.getItem("kfphone")}`;
      } else {
        let a = localStorage.getItem("openId");
        if (!a) {
          this.wxState();
          return;
        }
        this.$router.push({ name: "kf" });
      }
    },
    toCdKey() {
      if (this.userMes.phone) {
        this.$router.push({ name: "cdKey" });
      } else {
        this.wxState();
      }
    },
    toUserMes() {
      if (!this.userMes.phone) {
        this.wxState();
      }
    },
    toequity() {
      this.$router.push({ name: "equity" });
    },
    toLogin() {
      localStorage.removeItem("openId");
      if (this.userMes.phone) {
        this.http.loginOut().then((res) => {
          this.userMes = {};
          if (res.data.data) {
            window.location.href = res.data.data;
          } else {
            this.wxState();
          }
        });
      } else {
        this.wxState();
      }
    },
    getVipUrl(url) {
      if (!this.isLiantong || !this.userMes.phone) {
        if (!this.userMes.phone) this.wxState();
        return;
      }

      this.http.getVipUrl({ redirectUri: url }).then((res) => {
        if (res.data.status == 1) {
          window.location.href = res.data.msg;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    wxState() {
      const isWechat = /micromessenger/i.test(navigator.userAgent);
      if (isWechat) {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({ url: "/pages/login/login" });
          } else {
            this.toLoginRoute();
          }
        });
      } else {
        this.toLoginRoute();
      }
    },
    toLoginRoute() {
      sessionStorage.setItem("loginReturn", window.location.href);
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  background-color: #f6f6f6;
  min-height: 100vh;
  padding-bottom: 1.46rem;
  text-align: left;

  .minehead {
    height: 2.93rem;
    background: #e9f0f7;
    background-size: cover;
    position: relative;

    .changename {
      position: absolute;
      left: 0;
      right: 0;
      top: 0.5rem;
      display: flex;
      align-items: center;

      .headPic {
        width: 1.46rem;
        height: 1.46rem;
        margin: 0 0 0 20px;
        padding-top: 0.4rem;
        box-sizing: content-box;
      }

      .phoneNum {
        text-align: center;
        font-size: 0.32rem;
        color: #222222;
        margin-top: 0.28rem;
        padding-left: 0.3rem;
      }

      .changePhone {
        width: 16px;
        height: 16px;
        margin-left: 1.8rem;
        margin-top: 0.28rem;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .vipcss {
    width: 94%;
    margin: auto;
    position: relative;

    .absolute {
      position: absolute;
      left: 23%;
      bottom: 10%;
      color: #a4a4a4;
      line-height: 20px;
      font-size: 12px;
    }

    .dingwei {
      position: absolute;
      height: fit-content;
      right: 23px;
      top: 0;
      bottom: 0;
      margin: auto;

      .vipimg {
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 10px;
        color: black;
        background-color: #acdbff;
      }

      .tuiding {
        line-height: 20px;
        text-align: center;
        border-radius: 20px;
        color: #ababab;
        font-size: 12px;
        margin-top: 4px;
      }
    }
  }

  .container {
    padding: 5px 0 12px;
    background-color: #ffffff;
    width: 94%;
    margin: 10px auto;
    border-radius: 10px;

    .icon-grid {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;

      .icon-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 33.33%; // Adjusted for 3 items in iconList

        .icon-box {
          width: 42px;
          height: 42px;
          border-radius: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 8px;

          .icon-image {
            width: 100%;
            height: 100%;
          }
        }

        .icon-text {
          font-size: 12px;
          color: #333333;
          text-align: center;
        }
      }
    }
  }

  .mineList {
    padding: 0 8px;
    margin: 14px 0.29rem 0px 0.24rem;
    background: #fff;
    border-radius: 10px;

    .eachBlock {
      height: 1.09rem;
      line-height: 1.06rem;
      position: relative;
      display: flex;
      align-items: center;

      .eachIco {
        width: 0.78rem;
        display: flex;
        justify-content: center;

        img {
          width: 22px;
          height: 22px;
        }
      }

      .eachTit {
        font-size: 0.32rem;
        color: #616161;
        flex: 1;
      }

      .arrow {
        width: 0.14rem;
        height: 0.24rem;
        margin-right: 0.37rem;
      }
    }
  }

  .beian {
    text-align: center;
    font-size: 12px;
    position: fixed;
    bottom: 11%;
    left: 0;
    right: 0;
    color: #656565;
  }
}

.kf {
  text-align: center;
  div {
    height: 50px;
    line-height: 50px;
  }
}
</style>
